/**
 * A4 一枚もの履歴書（rirekisho_single / rirekisho_arbeit_debut）用の記入例。
 *
 * RirekishoSinglePreview は学歴・職歴欄が 10 行までで、2 枚もの用の rirekisho-sample を
 * そのまま入れると 11 行（見出し 2 + 学歴 5 + 空行 1 + 職歴 2 + 以上 1）になり
 * 行数オーバーのエラー表示（赤）になる。アプリ側の案内どおり義務教育課程の学歴を省いて 10 行に収める。
 */
import rirekishoSample from '@/assets/formats/sample/rirekisho-sample'

type EducationalHistory = {
  year: number | string
  month: number | string
  description: string
  uuid: string
}

type RirekishoSample = {
  basicData: Record<string, unknown>
  formatData: Record<string, unknown> & {
    educationalHistories: EducationalHistory[]
  }
}

const base = rirekishoSample as unknown as RirekishoSample

export default {
  ...base,
  formatData: {
    ...base.formatData,
    // 中学卒業の行を落として 1 行ぶん詰める
    educationalHistories: base.formatData.educationalHistories.filter(
      (item) => !/中学校/.test(item.description)
    )
  }
}
